export default {
  backgroundColor: '#fae9b4',
  borderRadius: 2,
  padding: '0 1px',
  marginLeft: -1,
};
